export default __webpack_public_path__ + "static/media/Farmer-Import-Template.ed70451c.xlsx";